exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".copy-context{display:-ms-flexbox;display:flex;height:100%;background:#fff;-ms-flex-direction:column;flex-direction:column}.copy-context .line{margin:3px 0;height:1px;width:100%;background-color:#ececec}.copy-context .copy-toolbar{display:-ms-flexbox;display:flex;height:38px;line-height:38px;text-align:center;color:#666}.copy-context .copy-toolbar .toolbar-btn{width:20%}.copy-context .copy-toolbar .toolbar-btn.ok-btn{color:#ffb403}.copy-context .copy-textarea{height:100%;width:100%}.copy-context .overflowHidden{overflow:hidden}", ""]);

// exports
